import React from "react";
import { Controls, FormGroup, IFormStyles, useFormStyles } from "../.";
import { FormGroupProps } from "../misc/formGroup";

interface FormSwitchProps extends Controls.ControlSwitchProps {
    isLoading?: boolean | undefined
    label?: string | undefined
    isOptional?: boolean | undefined;
    tooltip?: string | undefined;
}

const ComponentProps = (props: FormSwitchProps): Controls.ControlSwitchProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.isLoading;
    delete componentProps.label;
    delete componentProps.isOptional;
    delete componentProps.tooltip;

    return componentProps;
}

const GroupProps = (props: FormSwitchProps): FormGroupProps => {
    const groupProps: FormGroupProps = {
        controlStyles: props.controlStyles,
        isLoading: props.isLoading,
        disabled: props.disabled,
        groupType: "switch",

        label: props.label,
        isOptional: props.isOptional,
        tooltip: props.tooltip,
    };

    return groupProps;
}

export const FormSwitch: React.FC<Controls.ControlSwitchProps> = (props) => {
    const styles: IFormStyles = useFormStyles();

    return (
        <FormGroup  {...GroupProps(props)}>
            <Controls.ControlSwitch {...ComponentProps(props)} controlStyles={styles.control} />
        </FormGroup>
    );
};